import {mapProps} from 'recompose'
import {omit} from 'lodash'

const omitProps = (...keys) => mapProps(props => omit(props, keys))

export default omitProps
